export default "__VITE_ASSET__N$v9xy7r__"